import React from "react";

const GroupInput = (props) => {
  const {
    label = "",
    name = "",
    divClass = "input-group",
    labelClass = "",
    errorMsg,
    children,
    ...extra
  } = props;
  return (
    <li>
      <label className={labelClass}>{label}</label>
      <div className={divClass}>
        <input name={name} id={props?.id ?? name} type="text" {...extra} />
        {children ?? ""}
        {errorMsg ?? ""}
      </div>
    </li>
  );
};

export default GroupInput;
